import { MenuTrigger } from "react-native-popup-menu";
export default MenuTrigger;
